import { Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { Type } from 'src/app/pages/models/type/type.model';

@Component({
  selector: 'app-type-item',
  templateUrl: './type-item.component.html',
  styleUrls: ['./type-item.component.scss'],
})
export class TypeItemComponent{
  @Input() type: Type;
  @Output() clicked = new EventEmitter;

}
